// --------------------------------------------------------------------------
// Supabase client — singleton for the web dashboard
// --------------------------------------------------------------------------

import { createClient } from "@supabase/supabase-js";

const viteEnv = import.meta.env ?? {};
const supabaseUrl = viteEnv.VITE_SUPABASE_URL || "";
const supabaseAnonKey = viteEnv.VITE_SUPABASE_ANON_KEY || "";

// Warn in dev but don't crash — landing page works without auth
if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    "[peekop] Missing Supabase env vars (VITE_SUPABASE_URL, VITE_SUPABASE_ANON_KEY). Auth features disabled."
  );
}

export const supabase = supabaseUrl && supabaseAnonKey
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
      },
    })
  : null;
